import {createApp} from "vue";
import {createPinia} from "pinia";
import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";
import {definePreset} from "@primeuix/themes";
import App from "./App.vue";
import router from "./router";
import "./assets/styles.css";
import "./assets/scss/index.scss";

const AppPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: "#edf3ff",
            100: "#d8e5ff",
            200: "#b9d0ff",
            300: "#8eb2ff",
            400: "#5f8eff",
            500: "#145eee",
            600: "#0f4dd0",
            700: "#0f3eae",
            800: "#12378f",
            900: "#153278",
            950: "#0d1c46",
        },
    },
});

createApp(App)
    .use(createPinia())
    .use(PrimeVue, {
        theme: {
            preset: AppPreset,
            options: {
                darkModeSelector: false,
            },
        },
    })
    .use(router)
    .mount("#app");
